/* Range Slider Demo */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsRangeSliderDemo() {

    /* Loop Sliders */
    jQuery( '.form-range' ).each(function() {
        
        /* Setup */
        var element = jQuery( this );
        
        /* Add Div For Slider */
        element.append( document.createElement( 'div' ) );
        var slider = element.find( 'div' )[0];
        
        /* Create Slider */
        noUiSlider.create( slider , {
        	start: 4,
        	step: 1,
        	tooltips: wNumb({ decimals: 0 }),
        	range: {
        		'min': 4,
        		'max': 25
        	},
        	pips: {
    		    mode: 'steps',
                density: 21
    	    }
        });
        
        /* Create Hidden Input */
        var input = document.createElement( 'input' );
        jQuery( input ).attr({ type: 'hidden' , name: element.attr( 'id' ) });
        
        /* Add Input To Slider */
        element.append( input );
        
        /* Update Input */
        slider.noUiSlider.on( 'update' , function( values , handle ) {
            jQuery( input ).val( values[handle] );
        });
    
    });

}

/* Range Slider */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsRangeSlider( element , start , step , min , max , postfixSingular , postfixPlural , callback ) {

    /* IE 8 Fallback */
    if ( jQuery( 'html' ).hasClass( 'browser-ie8') ) {
        
        /* Check Exists */
        if ( element.length ) {
            
            /* Create Hidden Input */
            var input = document.createElement( 'input' );
            jQuery( input ).attr({ type: 'hidden' , name: element.attr( 'id' ) });
            
            /* Add Input To Slider */
            element.append( input );
        
            /* Build Select */
            var select = jQuery( '<select>' ).appendTo( element );
            select.addClass( 'form-select' );
            
            /* Build Options */
            var options = [];
            for ( i=min; i <= max; i += step ) {           
                options.push( { val: i, text: i, selected: ( start == i ? true : false ) } );
            }
            
            /* Add Options To Select */
            jQuery( options ).each(function() {
                var option = jQuery( '<option>' ).attr( 'value' , this.val ).text( this.text );
                if ( this.selected ) { option.attr( 'selected' , 'selected' ); }
                select.append( option );
            });
            
            /* On Change */
            select.on( 'change' , function() {
                
                /* Get Value */
                var value = select.val();
                
                /* Convert To Number */
                value = parseFloat( value );
                
                /* Update Input */
                jQuery( input ).val( value );
            
                /* Call Function */
                if ( typeof callback === 'function' ) {
                    callback( value );
                }
            
            });
            
            /* Wait For Redraw */
            setTimeout(function() {
                
                /* Fire Change */
                select.change();
            
            } , 1 );
        
        }
    
    /* Range Slider */
    } else {

        /* Check Exists */
        if ( element.length ) {
    
            /* Add Div For Slider */
            element.append( document.createElement( 'div' ) );
            var slider = element.find( 'div' )[0];
    
            /* Create Slider */
            noUiSlider.create( slider , {
            	start: start,
            	step: step,
            	range: {
            		'min': min,
            		'max': max
            	}
            });
            
            /* Create Hidden Input */
            var input = document.createElement( 'input' );
            jQuery( input ).attr({ type: 'hidden' , name: element.attr( 'id' ) });
            
            /* Add Input To Slider */
            element.append( input );
            
            /* Add Tool Tip */
            element.find( '.noUi-handle' ).html( '<div class="noUi-tooltip"></div>' );
            
            /* On Update */
            slider.noUiSlider.on( 'update' , function( value , handle ){
                
                /* Convert To Number */
                value = parseFloat( value );
                
                /* Update Input */
                jQuery( input ).val( value );
                
                /* Format Number */
                if ( value > 1 ) {
                    var format = wNumb({ decimals: 0 , postfix: ' ' + postfixPlural });
                } else {
                    var format = wNumb({ decimals: 0 , postfix: ' ' + postfixSingular });
                }
                
                /* Update Tooltip */
                element.find( '.noUi-tooltip' ).html( format.to( value ) );
    
                /* Minimum Class */
                if ( value <= 3 ) {
                    element.find( '.noUi-base' ).addClass( 'noUi-min-value' );
                } else {
                    element.find( '.noUi-base' ).removeClass( 'noUi-min-value' );
                }
                
                /* Maximum Class */
                if ( value >= max - 2 ) {
                    element.find( '.noUi-base' ).addClass( 'noUi-max-value' );
                } else {
                    element.find( '.noUi-base' ).removeClass( 'noUi-max-value' );
                }
                
                /* Call Function */
                if ( typeof callback === 'function' ) {
                    callback( value );
                }
            
            });
            
            /* Wait For Redraw */
            setTimeout(function() {
                
                /* Show Handle */
                element.find( '.noUi-base > div > div' ).css( 'display' , 'block' );
            
            } , 1 );
        
        }
    
    }

}